<template>
  <div class="admin">
    <div class="section create">
      <button class="button">
        <router-link :to="{ name: 'edit-hymn-create' }">Add Hymn</router-link>
      </button>
      <button class="button">
        <router-link :to="{ name: 'manage-categories' }">Manage Sub Categories</router-link>
      </button>
      <button class="button">
        <router-link :to="{ name: 'manage-parent-categories' }">Manage Parent Categories</router-link>
      </button>
    </div>
    <div class="columns">
      <div class="column is-one-third list-hymns">
        <h1 class="is-size-3">Search by Code</h1>
        <div class="columns">
          <div class="column">
            <input class="input" type="number" v-model="codeToGoTo" placeholder="Search by Code" />
          </div>
          <div class="column is-one-fifth">
            <button class="button" @click="doSearchByCode">Search</button>
          </div>
        </div>
        <HymnListing
          :hymns="searchByCodeHymns"
          :namespace="'coded_'"
          v-on:previewhymn="previewHymn"
        />
        <hr />
        <h1 class="is-size-3">Search by Content</h1>
        <div class="columns">
          <div class="column">
            <input class="input" type="text" v-model="searchQuery" placeholder="Search by content" />
          </div>
          <div class="column is-one-fifth">
            <button class="button" @click="doSearch">Search</button>
          </div>
        </div>
        <HymnListing
          :hymns="searchedHymns"
          :namespace="'searched_'"
          v-on:previewhymn="previewHymn"
        />
        <hr />
        <h1 class="is-size-3">Last 20 Hymns</h1>
        <HymnListing :hymns="hymns" :namespace="'listing_'" v-on:previewhymn="previewHymn" />
      </div>
      <div class="column view">
        <div v-if="hymnToView">
          <div class="columns">
            <div class="column">
              <p class="is-size-4 has-text-weight-bold">{{hymnToView.hymnCode}}</p>
            </div>
            <div class="column">
              <p>{{hymnToView.timeSignature}}</p>
            </div>
          </div>
          <p class="is-size-4">{{hymnToView.title}}</p>
          <p class="is-size-4">{{hymnToView.swahiliTitle}}</p>
          <pre class="content" v-html="hymnToView.content"></pre>
          <pre class="content" v-html="hymnToView.swahiliContent"></pre>
          <pre class="content" v-html="hymnToView.chords"></pre>
          <p><img :src="hymnToView.sheetMusic"/></p>
          <div class="column">
            <p>{{hymnToView.author}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { firestore } from "@/firebase";
// import marked from "marked";
import { index } from "@/algolia_util";
import HymnListing from "@/views/HymnListing";

export default {
  components: {
    HymnListing
  },
  data() {
    return {
      searchQuery: null,
      searchedHymns: null,
      hymnToView: null,
      hymns: null,
      codeToGoTo: null,
      searchByCodeHymns: null
    };
  },
  mounted() {
    firestore
      .collection("Hymns")
      .orderBy("hymnCode", "desc")
      .limit(20)
      .onSnapshot(snapshot => {
        let hymns = snapshot.docs.map(d => {
          var data = d.data();
          data.id = d.id;
          return data;
        });
        this.hymns = hymns.sort((a, b) => (a.hymnCode > b.hymnCode ? -1 : 1));
        if (this.hymnToView == null) {
          this.hymnToView = this.hymns[0];
        }
      });
  },
  methods: {
    previewHymn: function(eventData) {
      console.log(eventData);
      firestore
        .collection("Hymns")
        .doc(eventData.hymnId)
        .get()
        .then(snapshot => {
          let d = snapshot.data();
          d.id = snapshot.id;
          this.hymnToView = d;
        });
    },
    doSearch: function() {
      index
        .search(this.searchQuery, {
          hitsPerPage: 5
        })
        .then(({ hits }) => {
          hits.forEach(hit => {
            hit.id = hit.objectID;
          });
          this.searchedHymns = hits;
        });
    },
    doSearchByCode: function() {
      firestore
        .collection("Hymns")
        .where("hymnCode", "==", parseInt(this.codeToGoTo))
        .get()
        .then(snapshot => {
          let hymns = snapshot.docs.map(d => {
            var data = d.data();
            data.id = d.id;
            return data;
          });
          this.searchByCodeHymns = hymns.sort((a, b) =>
            a.hymnCode > b.hymnCode ? -1 : 1
          );
        });
    },
    uploadHymnsToSearch: function() {
      for(var x = 0; x < this.hymns.length; x ++) {
        var dataToSave = this.hymns[x];
        dataToSave.objectID = dataToSave.id;
        index.saveObjects([dataToSave]).then(() => {
          console.log("Hymn added on Algolia", dataToSave.hymnCode);
        });
      }
    }
  },
  computed: {
  }
};
</script>

<style scoped>
p button {
  margin-left: 5px;
}
.dates button {
  display: block;
  margin-bottom: 3px;
  margin-top: 3px;
}

.divider {
  height: 10px;
  margin: 10px 0px;
}

.create .button {
  margin-right: 10px;
}
</style>
